const MainBodyLayout = ({ children }) => (
  <div className={`flex flex-col !w-full relative px-[12px] pb-[8px]`} style={{background: "var(--color-bg-default)"}}>
    <div className="grid px-[24px] lg:px-[32px] grid-flow-col justify-between align-self-start content-start w-full bottom-0"></div>
    {children}
  </div>
);

export default MainBodyLayout;
